<template>
  <div>
    <timer-stop :activeTimeLog="activeTimeLog" v-if="activeTimeLog"></timer-stop>
    <timer-start :startTimeLimit="lastTimeLogStoppedAt" v-else></timer-start>
  </div>
</template>

<script>
  import moment from 'moment';
  import TimerStart from '@/components/TimerStart';
  import TimerStop from '@/components/TimerStop';

  export default {
    name: 'Timer',
    components: {
      timerStart: TimerStart,
      timerStop: TimerStop,
    },
    data() {
      return {
        today: moment(),
      };
    },
    computed: {
      activeTimeLog() {
        return this.$store.getters['entities/timeLogs/query']()
          .with('category')
          .where(record => record.stopped_at === null)
          .where('deleted', false)
          .first();
      },
      lastTimeLogStoppedAt() {
        const startOfDay = this.today.clone().startOf('day');
        const endOfDay = this.today.clone().endOf('day');
        const timeLogs = this.$store.getters['entities/timeLogs/query']()
          .where(record => record.stopped_at !== null)
          .where(record => moment(record.started_at).isBetween(startOfDay, endOfDay) || moment(record.stopped_at).isBetween(startOfDay, endOfDay))
          .where('deleted', false)
          .orderBy('stopped_at', 'desc')
          .get();

        return timeLogs && timeLogs.length ? timeLogs[0].stopped_at : null;
      },
    },
    methods: {
    },
  };
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Timer.vue